<template>
  <main id="main">
    <header class="header_page shadow_box slideInDown">
        <p id="title_header_page" class="bold">{{ t('followers_list') }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </header>

    <div class="p-3 d-flex flex-column row-gap-3 pb-5">
        <div v-if="loading" class="text-center mt-5">
            <p>{{ t('loading') }}</p>
        </div>
        
        <div v-else-if="followers.length === 0" class="text-center mt-5 text_color_gray">
            {{ t('no_followers') }}
        </div>

        <section v-else v-for="(follower, index) in followers" :key="index" class="w-100 bg-white p-3 rounded-pill shadow d-flex align-items-center">
            <img :src="follower.pic" class="avatar" @error="$event.target.src = require('@/assets/imgs/avatar.svg')">
            <span class="font_larger bold mr-3 ms-3">{{ follower.user_name }}</span>
        </section>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'FollowersList',
  data() {
    return {
        followers: [],
        loading: false
    }
  },
  mounted() {
    this.fetchFollowers();
  },
  methods: {
    async fetchFollowers() {
        this.loading = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId
            });

            const response = await apiClient.post('/teacher/show_followers', formData);

            if (response.data.status === 'ok' && response.data.data) {
                this.followers = response.data.data;
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.loading = false;
        }
    }
  }
}
</script>

<style scoped>
.avatar {
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #f1f1f1;
}
</style>